 export function initSlider() {

const track = document.querySelector<HTMLDivElement>('#slider')!;
const prevBtn = document.querySelector<HTMLButtonElement>('#prev')!;
const nextBtn = document.querySelector<HTMLButtonElement>('#next')!;

function step(): number {
  const first = track.firstElementChild as HTMLElement | null;
  if (!first) return 0;
  const style = getComputedStyle(track);
  const gap = parseInt(style.columnGap || style.gap || '0', 10);
  return first.offsetWidth + gap; 
}

function go(dir: 1 | -1) {
  track.scrollBy({ left: dir * step(), behavior: 'smooth' });
}

prevBtn?.addEventListener('click', () => go(-1));
nextBtn?.addEventListener('click', () => go(1));


let isDragging = false;
let startX = 0;

function thresholdPx() {
  const s = step();
  return Math.max(40, Math.min(120, Math.round(s * 0.25)));
}

track.addEventListener('pointerdown', (e) => {
  isDragging = true;
  startX = e.clientX;
  track.setPointerCapture(e.pointerId);
  track.style.cursor = 'grabbing';
});

track.addEventListener('pointermove', (e) => {
  if (!isDragging) return;
  
  e.preventDefault();
});

function endSwipe(e: PointerEvent) {
  if (!isDragging) return;
  isDragging = false;
  track.releasePointerCapture?.(e.pointerId);
  track.style.cursor = '';

  const dx = e.clientX - startX; 
  const T = thresholdPx();
  if (dx <= -T) go(1);        
  else if (dx >= T) go(-1);   
}

track.addEventListener('pointerup', endSwipe);
track.addEventListener('pointercancel', endSwipe);

 }
